module.exports = __webpack_public_path__ + "img/8-6.860bb404.png";